import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { i18n } from './plugins/i18n';
import '@/styles/main.scss';
import { initFaro } from '@/utils/faro';

const app = createApp(App);
app.use(router);
app.use(createPinia());
app.use(i18n);

app.mount('#app');
setTimeout(() => initFaro(), 0);
